/**
 * Mensagens de erros customizadas para a validação de campos
 */
 export default {
  pt: {
    required: "Esse campo é obrigatório",
  },
};
